import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as myGlobals from '../../globals';
import { ConfigService } from '../../config.service';



@Injectable()
export class TasksService {

  private _getBookingHistory = myGlobals.apiurl + 'dispatcher/bookingHistory';
  private _getdataUrl = myGlobals.apiurl + 'dispatcher/booking';
  private _cancelBOokingAfter = myGlobals.apiurl + 'dispatcher/cancelBookingAfterAccept';
  private _cancelfees = myGlobals.apiurl + 'dispatcher/cancellationFees';
  private _cancelreasons = myGlobals.apiurl + 'dispatcher/cancellationReasonRide';
  private _cancelservice = myGlobals.apiurl + 'dispatcher/cancelBookingAfterAccept';
  private _allbookings = myGlobals.apiurl + 'dispatcher/booking';



  constructor(
    private _router: Router,
    private _http: HttpClient,
    private _conf: ConfigService
  ) { }


  // START UBER FOR ALL API FUNCTIONS
  getAllBooking(user: any) {
    const obj = {
      status: user.status,
      fromDate: user.fromDate,
      toDate: user.toDate,
      search: user.search
    }
    return this._http.post(this._allbookings + '/' + 4 + '/' + user.limit + '/' + user.skip + '/' + user.cityId, obj, { headers: this._conf.header });
  }

  // get data
  getdata(user: any) {
    return this._http.get(this._getdataUrl + '/' + user.bookingId + '/' + 2, { headers: this._conf.header });
  }

  cancelreasons(user: any) {
    return this._http.get(this._cancelreasons, { headers: this._conf.header });
  }
  gethistory(user: any) {
    return this._http.get(this._getBookingHistory, { headers: this._conf.header });
  }
}
